import { Icon } from '@modulor/react';
import {
  BONUS_DETAIL,
  BONUSES_HISTORY,
  BONUSES_LIST,
  CAMPAIGN_DETAIL,
  TOURNAMENTS,
} from '../../../constants/routeTemplates';
import { ANALYTICS_SCREEN_AREA_DETAILS } from '../../../constants/analytics';
import type { MainNavigationItem, MainNavigationPredicates } from './types';
import BonusesNotification from './components/BonusesNotification';
import { getPromoBonusUrl } from '../../../hooks/usePromoBonusSystemRedirects';
import { PROMO } from '../../../constants/productTypes';
import {
  getRootRoute,
  getCurrentBonusesRoute,
  getBonusGamesWageringRoute,
  getGameDetailRoute,
  getFavoritesRoute,
  getRecentGamesRoute,
} from '../../../utils/routes';

export const FREE_SPINS_NAVIGATION_ITEM_ID = 'FREE_SPINS_NAVIGATION_ITEM_ID';

export const navigationItems: MainNavigationItem[] = [
  {
    translationKey: 'Main',
    linkPathBuilder: getRootRoute,
    Icon: (props = {}) => <Icon name="home_outlined" {...props} />,
    analyticsData: {
      analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.MAIN_PAGE,
    },
  },
  {
    Icon: (props = {}) => <Icon name="gift_outlined" {...props} />,
    id: BONUSES_LIST,
    translationKey: 'Bonuses',
    linkPathBuilder: getCurrentBonusesRoute,
    analyticsData: { analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.BONUS },
    activeRoutes: [
      BONUSES_LIST,
      BONUSES_HISTORY,
      BONUS_DETAIL,
      CAMPAIGN_DETAIL,
    ],
    rightCellContent: <BonusesNotification />,
    predicateResolver: ({
      isEnabledBonusesSystem,
      isUnifiedPromoBonusSystemEnabled,
    }: MainNavigationPredicates) => {
      return isEnabledBonusesSystem && !isUnifiedPromoBonusSystemEnabled;
    },
  },
  // unified bonus system item
  {
    Icon: (props = {}) => <Icon name="gift_outlined" {...props} />,
    id: BONUSES_LIST,
    translationKey: 'Bonuses',
    linkPathBuilder: () => getPromoBonusUrl(),
    productType: PROMO,
    analyticsData: { analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.BONUS },
    activeRoutes: [
      BONUSES_LIST,
      BONUSES_HISTORY,
      BONUS_DETAIL,
      CAMPAIGN_DETAIL,
    ],
    rightCellContent: <BonusesNotification />,
    predicateResolver: ({
      isEnabledBonusesSystem,
      isUnifiedPromoBonusSystemEnabled,
    }: MainNavigationPredicates) => {
      return isEnabledBonusesSystem && isUnifiedPromoBonusSystemEnabled;
    },
  },
  {
    Icon: (props = {}) => <Icon name="cup_outlined" {...props} />,
    id: TOURNAMENTS,
    translationKey: 'Tournaments',
    linkPathBuilder: () => TOURNAMENTS,
    predicateResolver: ({
      isTournamentLobbyAvailable,
    }: MainNavigationPredicates) => {
      return isTournamentLobbyAvailable;
    },
  },
  {
    Icon: (props = {}) => <Icon name="wager" {...props} />,
    translationKey: 'Games for wagering',
    linkPathBuilder: getBonusGamesWageringRoute,
    analyticsData: {
      analyticAreaDetail:
        ANALYTICS_SCREEN_AREA_DETAILS.WAGERING_GAMES_PAGE_CLICK,
    },
    predicateResolver: ({
      isWageringGamesAvailable,
      isLoggedIn,
    }: MainNavigationPredicates) => {
      return isLoggedIn && isWageringGamesAvailable;
    },
  },
  {
    Icon: (props = {}) => <Icon name="free_spins" {...props} />,
    id: FREE_SPINS_NAVIGATION_ITEM_ID,
    translationKey: 'Free spins',
    // will be remapped further
    linkPathBuilder: getGameDetailRoute,
    analyticsData: {
      analyticAreaDetail:
        ANALYTICS_SCREEN_AREA_DETAILS.WAGERING_GAMES_PAGE_CLICK,
    },
    predicateResolver: ({
      shouldDisplayFreeSpinsButton,
      isLoggedIn,
    }: MainNavigationPredicates) => {
      return isLoggedIn && shouldDisplayFreeSpinsButton;
    },
  },

  {
    Icon: (props = {}) => <Icon name="star_filled" {...props} />,
    translationKey: 'Favorites',
    linkPathBuilder: getFavoritesRoute,
    analyticsData: {
      analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.FAVORITE_PAGE_CLICK,
    },
    predicateResolver: ({
      isEnabledFavoriteGames,
      isLoggedIn,
    }: MainNavigationPredicates) => {
      return isLoggedIn && isEnabledFavoriteGames;
    },
  },

  {
    Icon: (props = {}) => <Icon name="history_outlined" {...props} />,
    translationKey: 'Recent games',
    linkPathBuilder: getRecentGamesRoute,
    analyticsData: {
      analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.RECENT_GAME,
    },
    predicateResolver: ({ isSCCOM }: MainNavigationPredicates) => {
      return isSCCOM;
    },
  },
];
